
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ImportService } from '../../service/import.service';
import { ImportHistory } from '../../model/import-history';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MenuItem, MessageService } from 'primeng/api';
import { Shop } from '../../../shop/types/shop.type';
import { DatePipe, NgClass } from '@angular/common';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ShopService } from '../../../shop/service/shop.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../user/services/user.service';
import { Util } from '../../../../utils/util';
import { ExportService } from '../../../../services/export/export.service';
import { User } from '../../../user/models/user.type';
import { NgxPermissionsService } from 'ngx-permissions';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { BadgeModule } from 'primeng/badge';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FiltersUtil } from '../../../catalog/product-list/utils/filters-util';
import { FilterProductComponent } from '../../../catalog/product/filter/filter-product/filter-product.component';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ChannelService } from '../../service/channel.service';
import { TooltipModule } from 'primeng/tooltip';
import { Message } from 'primeng/message';

@Component({
  selector: 'app-import-history',
  standalone: true,
  imports: [
    TableModule,
    TagModule,
    ButtonModule,
    MenuModule,
    DatePipe,
    SplitButtonModule,
    TranslateModule,
    NgClass,
    IconFieldModule,
    InputIconModule,
    BadgeModule,
    SelectModule,
    FormsModule,
    ToastModule,
    TooltipModule,
    Message
  ],
  templateUrl: './import-history.component.html',
  styleUrl: './import-history.component.scss',
  providers: [TranslateService, MessageService, DialogService],
})
export class ImportHistoryComponent implements OnInit {
  @Input() status: string[] = [];
  @Input() max: number;
  @Input() showErrors: boolean = false;
  @Input() hideSearch: boolean = false;
  @Input() hideFilters: boolean = false;
  @Input() onRowClick: boolean = false;
  error;
  importHistory: ImportHistory[];
  selectedShop: Shop;
  items: MenuItem[];
  isLoading: boolean = false;
  headers: any[] = [
    this.createHeaderColumn({ id: 'fileName', value: 'table.name', frozen: true }),
    this.createHeaderColumn({ id: 'importDate', value: 'table.importDate' }),
    this.createHeaderColumn({ id: 'sourceImport', value: 'table.importSource' }),
    this.createHeaderColumn({ id: 'format', value: 'Format' }),
    this.createHeaderColumn({ id: 'status', value: 'table.status' }),
    this.createHeaderColumn({ id: 'linesImportSuccess', value: 'table.importedItems' }),
    this.createHeaderColumn({ id: 'linesRejected', value: 'table.linesRejected', tooltip: true, tooltipValue: 'importHistory.linesRejected', }),
    this.createHeaderColumn({ id: 'linesWithErrors', value: 'table.linesInError', tooltip: true, tooltipValue: 'importHistory.linesInError', }),
    this.createHeaderColumn({ id: 'filteredLines', value: 'table.filteredLines', tooltip: true, tooltipValue: 'importHistory.filteredLines', }),
    this.createHeaderColumn({ id: 'mappingNeeded', value: 'table.mappingNeeded' }),
    this.createHeaderColumn({ id: 'shopName', value: 'table.shopName' }),
    this.createHeaderColumn({ id: 'aggregatorName', value: 'table.aggregatorName' }),
    this.createHeaderColumn({ id: 'importId', value: 'table.importId' }),
  ];
  user: User;
  shops: Shop[];
  filters = [];
  appliedFilters = {};
  tags = [];
  searchFilters = {};
  rows = 100;
  searchData: any = {
    shopCode: null,
    keyword: '',
    page: 1,
    size: this.rows,
    orderBy: null,
    orderDir: null,
    filters: {
      status: [],
      fromDate: null,
      toDate: null,
    },
    isOperator: false,
  };
  ref: DynamicDialogRef | undefined;
  totalRecords: number;
  rowsPerPageOptions = [
    { label: '50', value: 50 },
    { label: '100', value: 100 },
    { label: '200', value: 200 },
  ];
  isOperator = false;
  @Input() aggregators= [];
  @Input() shopsFilters = [];
  @Input() hasNext: boolean;
  @ViewChild('dt2') dt2: Table;

  constructor(
    private readonly translate: TranslateService,
    private readonly importService: ImportService,
    private readonly router: Router,
    private readonly shopService: ShopService,
    private readonly userService: UserService,
    private readonly exportService: ExportService,
    private readonly permissionService: NgxPermissionsService,
    private readonly dialogService: DialogService,
    private readonly messageService: MessageService,
    private readonly channelService: ChannelService,
  ) {}

  ngOnInit(): void {
    this.setupHeaders();
    this.initUserAndShops();
  }
  private createHeaderColumn(params: {
    id: string;
    value: string;
    sortField?: string;
    frozen?: boolean;
    tooltip?: boolean;
    tooltipValue?: string;
  }) {
    return {
      id: params.id,
      value: params.value,
      sortField: params.sortField || params.id,
      frozen: params.frozen || false,
      tooltip: params.tooltip || false,
      tooltipValue: params.tooltipValue || '',
    };
  }
  private setupHeaders(): void {
    if (this.max == undefined) {
      this.headers.push({
        id: 'download',
        value: '',
        sortColumn: 'false',
        frozen: true,
      });
    }
  }

  private initUserAndShops(): void {
    this.user = this.userService.getUser();
    if (this.user?.operator) {
      this.isOperator = true;
      if (
        this.permissionService.getPermission(
          'PERMISSION_IMPORT_OPERATOR_SELLER',
        )
      ) {
        this.shops = this.user.relatedShops;
      } else {
        this.loadAllShops();
      }
    } else {
      this.shops = this.user.relatedShops;
    }
  }

  loadHistory(): void {
    const code = this.shopService.getSelectedShopCode();
    this.selectedShop = this.shops?.find((shop) => shop.shopCode === code);
    this.getImportsHistory(this.selectedShop);
  }

  loadAllShops(): void {
    this.shopService.getAllShop().subscribe({
      next: (res) => {
        this.shops = res;
        if (this.shops?.length) {
          this.selectedShop = this.shops[0];
        }
      },
    });
  }

  getImportsHistory(selectedShop: Shop): void {
    this.applyFilter();
    this.prepareSearchData(selectedShop);
    this.isLoading = true;
    if (this.onRowClick && this.status.length != 0) {
      this.searchData.filters['status'] = this.status;
    }
    this.importService.getImportsHistory(this.searchData).subscribe({
      next: (res) => {
        this.processImportHistoryResponse(res);
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  private prepareSearchData(selectedShop: Shop): void {
    this.searchData.shopCode = this.isOperator
      ? this.searchData.filters['shopCode']
      : [selectedShop?.shopCode];
    this.searchData.isOperator = this.isOperator;
  }

  private processImportHistoryResponse(res: any): void {
    this.checkForErrorsInLatestImport(res);
    this.filterImportHistory(res);
    this.addActionsToHistory();
    this.applyMaxLimit();
    this.totalRecords = res.totalRecords;
    this.isLoading = false;
  }

  private checkForErrorsInLatestImport(res: any): void {
    if (res.imports.length > 0 && this.searchData.page == 1) {
      const lastImport = this.findLatestImport(res.imports);
      if (lastImport?.linesWithErrors != 0) {
        this.error = 
          {
            severity: 'warn',
            text: this.translate.instant(
              'importWorkflow.errorReportMessage',
            ),
          };
      }
    }
  }

  private findLatestImport(imports: any[]): any {
    return imports?.reduce(
      (latest, current) =>
        new Date(current.importDate) > new Date(latest.importDate)
          ? current
          : latest,
      imports[0],
    );
  }

  private filterImportHistory(res: any): void {
    this.importHistory = res.imports;
  }

  private addActionsToHistory(): void {
    for (const history of this.importHistory) {
      history.actions = this.createHistoryActions(history);
    }
  }

  private createHistoryActions(history: ImportHistory): any[] {
    const actionsWithoutTransformedFile = [
      this.createAction(
        'importHistory.importFile',
        'pi pi-fw pi-file text-primary',
        () => this.downloadItem(history.importId, 'SOURCE'),
      ),
      this.createAction(
        'importHistory.errorFile',
        'pi pi-fw pi-file text-red-500',
        () => this.downloadItem(history.importId, 'ERROR'),
      ),
    ];
    const actionsWithTransformedFile = [
      this.createAction(
        'importHistory.importFile',
        'pi pi-fw pi-file text-primary',
        () => this.downloadItem(history.importId, 'SOURCE'),
      ),
      this.createAction(
        'importHistory.transformedFile',
        'pi pi-fw pi-file text-green-500',
        () => this.downloadItem(history.importId, 'TRANSFORMED'),
      ),
      this.createAction(
        'importHistory.errorFile',
        'pi pi-fw pi-file text-red-500',
        () => this.downloadItem(history.importId, 'ERROR'),
      ),
    ];
    return !history.mappingNeeded || history.status === 'MAPPING_INTERRUPTED'
      ? actionsWithoutTransformedFile
      : actionsWithTransformedFile;
  }

  private createAction(label: string, icon: string, command: () => void): any {
    return {
      label: this.translate.instant(label),
      icon: icon,
      command: command,
    };
  }

  private applyMaxLimit(): void {
    if (this.max) {
      this.importHistory = this.importHistory.slice(0, this.max);
    }
  }

  getSeverity(error: string) {
    return Util.getSeverity(error);
  }

  rowClick(event, row): void {
    if (this.onRowClick && row.status === 'AWAITING_MAPPING') {
      this.shopService.getShop(row.shopCode).subscribe({
        next: (shop: Shop) => {
          const locales = this.channelService.getLocalesForMapping(
            shop.shopChannel,
          );
          const selectedLocale = locales?.[0];

          this.router.navigate(['/import/progress/' + row.importId], {
            queryParams: {
              importShopCode: row.shopCode,
              importLocale: selectedLocale,
            },
          });
        },
      });
    }
  }

  downloadItem(importId: string, type: string): void {
    const data = {
      fileType: type,
      importId: importId,
    };

    this.exportService.downloadFile(data).subscribe({
      next: (response) => Util.handleExportSuccess(response),
      error: (error) => {
        if (error.status == 404) {
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('alerts.errorSummary'),
            detail: this.translate.instant('alerts.exportError'),
          });
        }
      },
    });
  }

  onButtonClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  onDropdownClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  getImportReportButtonSeverity(importHistory: ImportHistory): string {
    return importHistory.linesWithErrors > 0 ||
      importHistory.status === 'INTEGRATION_FAILED' ||
      importHistory.linesRejected > 0 ||
      importHistory.status === 'INVALID_FILE_FORMAT'
      ? 'warning-split-button'
      : 'p-button-primary';
  }

  filterGlobal(event): void {
    this.searchData.keyword = event.target.value;
    this.onLazyLoad({
      first: 0,
      rows: this.rows,
      sortField: null,
      sortOrder: null,
    });
  }

  openFilterModal(): void {
    this.initFilters();
    this.ref = this.dialogService.open(FilterProductComponent, {
      header: this.translate.instant('global.filter'),
      dismissableMask: true,
      focusOnShow: false,
      closable: true, 
      data: { filters: this.filters, appliedFilters: this.appliedFilters },
      width: '80vw',
      height: '75vh',
      modal: true,
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
    });

    this.ref.onClose.subscribe((data) => {
      if (data) {
        this.handleFilters(data);
        this.onLazyLoad({
          first: 0,
          rows: this.rows,
          sortField: null,
          sortOrder: null,
        });
      }
    });
  }

  initFilters(): void {
    this.filters = [];
    this.addStatusFilter();
    this.addDateFilter();
    this.addShopFilterIfOperator();
    this.addAggregatorFilter();
  }

  private addStatusFilter(): void {
    this.filters.push({
      type: 'select',
      search: false,
      name: 'importStatus',
      key: 'key',
      display: 'name',
      header: 'filters.status',
      values: [
        {
          name: this.translate.instant('INTEGRATION_FAILED'),
          key: 'INTEGRATION_FAILED',
        },
        {
          name: this.translate.instant('INTEGRATION_FINISHED'),
          key: 'INTEGRATION_FINISHED',
        },
        {
          name: this.translate.instant('INVALID_FILE_FORMAT'),
          key: 'INVALID_FILE_FORMAT',
        },
        {
          name: this.translate.instant('IMPORT_IN_PROGRESS'),
          key: 'IMPORT_IN_PROGRESS',
        },
        {
          name: this.translate.instant('MAPPING_INTERRUPTED'),
          key: 'MAPPING_INTERRUPTED',
        },
        {
          name: this.translate.instant('AWAITING_MAPPING'),
          key: 'AWAITING_MAPPING',
        },
      ],
    });
  }

  private addDateFilter(): void {
    this.filters.push({
      type: 'date',
      name: 'importDate',
      header: 'filters.importDate',
    });
  }

  private addShopFilterIfOperator(): void {
    if (this.isOperator) {
      this.filters.push({
        type: 'list',
        search: false,
        name: 'shopMultipleWithShopCode',
        key: 'shopCode',
        display: 'shopNameWithChannel',
        header: 'filters.shops',
        values: this.shopsFilters,
        hasNext: this.hasNext,
        selectionMode: 'multiple',
      });
    }
  }

  addAggregatorFilter(): void {
    if (this.isOperator) {
      this.filters.push({
        type: 'list',
        search: true,
        name: 'aggregators',
        key: 'aggregatorCode',
        display: 'name',
        header: 'shop.aggregator',
        values: this.aggregators,
        selectionMode: 'multiple',
      });
    }
  }

  handleFilters(data): void {
    if (!data) {
      return;
    }

    this.tags = [];
    this.searchFilters = {};

    for (let key in data) {
      if (data[key]) {
        this.appliedFilters[key] = data[key];
        let tags;
        let filters = {};
        [tags, filters] = FiltersUtil.handleFilters(data, key);
        this.searchFilters[key] = filters;
        if (tags.length > 0) {
          this.tags = this.tags.concat(tags);
        }
      }
    }
  }

  resetFilters(): void {
    this.tags = [];
    this.searchFilters = {};
    this.appliedFilters = {};
    this.onLazyLoad({
      first: 0,
      rows: this.rows,
      sortField: null,
      sortOrder: null,
    });
  }

  removeFilter(val, parent): void {
    console.log(val, parent)
    const filterMap = {
      status: 'importStatus',
      dates: 'importDate',
      shops: 'shopMultipleWithShopCode',
      aggregators: 'aggregators',
    };
    Util.removeFilter(val, parent, this, this.onLazyLoad, this.rows, filterMap);
  }

  onRowsPerPageChange(event: any): void {
    this.rows = event.value;
    event.rows = this.rows;
    event.first = this.searchData.page;
    this.onLazyLoad(event);
  }

  onLazyLoad(event: TableLazyLoadEvent): void {
    if (event.first == 0 && this.dt2 != undefined) {
      this.dt2.first = 0;
    }

    this.updateSearchDataFromEvent(event);
    this.loadHistory();
  }

  private updateSearchDataFromEvent(event: TableLazyLoadEvent): void {
    this.searchData.page = Math.floor(event.first / event.rows) + 1;
    this.searchData.size = event.rows;
    this.searchData.orderBy = event.sortField;
    this.searchData.orderDir = event.sortOrder === 1 ? 'ASC' : 'DESC';
  }

  applyFilter(): void {
    this.resetFilterValues();

    for (let key in this.searchFilters) {
      this.processFilterByKey(key);
    }
  }

  private resetFilterValues(): void {
    this.searchData.filters['status'] = [];
    this.searchData.filters['fromDate'] = null;
    this.searchData.filters['toDate'] = null;
    this.searchData.filters['shopCode'] = [];
    this.searchData.filters['aggregators'] = [];
  }

  private processFilterByKey(key: string): void {
    const filterHandlers = {
      importStatus: () =>
        (this.searchData.filters['status'] = this.searchFilters[key]),
      importDate: () => {
        this.searchData.filters['fromDate'] =
          this.searchFilters[key][0] ?? null;
        this.searchData.filters['toDate'] = this.searchFilters[key][1] ?? null;
      },
      shopMultipleWithShopCode: () =>
        (this.searchData.filters['shopCode'] = this.searchFilters[key]),
      aggregators: () =>
        (this.searchData.filters['aggregators'] = this.searchFilters[key]),
    };

    if (filterHandlers[key]) {
      filterHandlers[key]();
    } else {
      this.searchData.filters[key] = this.searchFilters[key];
    }
  }
}
